import { render, staticRenderFns } from "./att_table.vue?vue&type=template&id=14ea70b2&scoped=true&"
import script from "./att_table.vue?vue&type=script&lang=js&"
export * from "./att_table.vue?vue&type=script&lang=js&"
import style0 from "./att_table.css?vue&type=style&index=0&id=14ea70b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ea70b2",
  null
  
)

export default component.exports